<template>
    <!-- 用户头像 -->
    <img v-if="userInfo.avatar"
        :src="userInfo.avatar"
        :alt="userInfo.nickname"
        @click="toUserInfo">
</template>

<script>
import {mapState} from 'vuex';

export default {
    props: {
        userInfo: Object
    },
    computed: {
        ...mapState({
            isPc: state => state.common.isPc,
            webPages: state => state.common.webPages
        })
    },
    methods: {
        toUserInfo() {
            if (!this.isPc) {
                return;
            }
            const userNo = this.userInfo.userNo;
            window.open(`${this.webPages.userInfo}/${userNo}`);
        }
    }
};
</script>
